import { HttpErrorResponse } from '@angular/common/http';

export const PARTY_REVISION_CONFLICT_MESSAGE = 'This case was updated elsewhere. Reload and try again.';
export const REVIEWER_REVISION_CONFLICT_MESSAGE = 'This assignment was updated elsewhere. Reload and try again.';

export class RevisionConflictError extends Error {
  constructor(
    message: string,
    readonly detail: string | null = null,
  ) {
    super(message);
    this.name = 'RevisionConflictError';
  }
}

export function revisionConflictFromHttp(error: unknown, message: string): RevisionConflictError | null {
  if (!(error instanceof HttpErrorResponse) || error.status !== 409) return null;

  const detail = error.error && typeof error.error === 'object' && 'detail' in error.error ? error.error.detail : null;
  return new RevisionConflictError(message, typeof detail === 'string' && detail.trim() ? detail : null);
}
